export function modals()
{
	$('.person-modal').on('click', function (e) {

		e.preventDefault();

		let trigger = $(this).attr('data-person-trigger');
		$('.module-person__modal-wrapper[data-person-modal="' + trigger + '"]').addClass('active');
		// $('.module-person .modal-clicktrap').addClass('active');

	});

	$('.module-person__modal-person .modal-close, .module-person__modal-wrapper .modal-clicktrap').on('click', function (e) {

		e.preventDefault();

		console.log('clicked');

		$('.module-person__modal-wrapper.active').removeClass('active');
		// $('.module-person .modal-clicktrap').removeClass('active');

	});
}



// WEBPACK FOOTER //
// ./scripts/modules/person-modals.js